
import { setAdminAuditInfo } from '@/api/task/admin'
import { setAuditStatusRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { setAntRegisterReview } from '@/api/task/antRegister'

@Component({
  name: 'review',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  private statusList: any[] = []
  private setForm: any = {
    status: null
  }
  private rules = setAuditStatusRules
  private loading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.setForm = {
      status: null
    }
    this.loading = false
    this.$emit('close')
  }

  private async auditOrder() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          id: this.info.id,
          ...this.setForm
        }
        try {
          await setAntRegisterReview(data).then((res: any) => {
            this.$message({
              message: 'Operation is successful!',
              type: 'success'
            })

            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }
}
